import axios from "@/utils/axios";

enum Api {
  queryList = "/wxapi/wechat/visitor/list",
  add = "/wxapi/wechat/visitor/add",
  insert = "/system/api/open/visitor/add",
  queryCompanyList = "/system/api/open/visitor/companyList",
  queryDeptList = "/system/api/open/visitor/deptList",
  queryPersonList = "/system/api/open/visitor/personList",
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace Visitor {
  export interface addForm {
    name: string;
    phone: number | string;
    cardId?: string;
    beginTime: string;
    endTime: string;
    visitorNum: number | string;
    visitReason: string;
    license?: string;
    photoPath: string;
  }
  export interface insertForm {
    companyId: number | string;
    deptId: number | string;
    interviewerId: number | string;
    name: string;
    phone: number | string;
    cardId?: string;
    beginTime: string;
    endTime: string;
    visitorNum: number | string;
    visitReason: string;
    workUnit?: string;
    license?: string;
    photoPath: string;
  }
  export interface queryCompany {
    searchValue: string;
  }
  export interface queryDept {
    companyId: number | string;
    searchValue: string;
  }
  export interface queryPerson {
    companyId: number | string;
    deptId: number | string;
    searchValue: string;
  }
  export interface listQueryParams {
    pageNum: string | number;
    pageSize: string | number;
    name?: string;
  }
}

// 查询访客列表
export const getVisitorList = (params: Visitor.listQueryParams) => {
  return axios.get(Api.queryList, params);
};

// 家长来访--新增
export const addVistor = (params: Visitor.addForm) => {
  return axios.post(Api.add, params);
};

// 普通来访--新增
export const insertVistor = (params: Visitor.insertForm) => {
  // return axios.post(Api.insert, params);
  return axios.http({
    url: Api.insert,
    headers: {
      isToken: false,
    },
    method: "post",
    data: params,
  });
};
// 企业搜索列表
export const getCompanyList = (params: Visitor.queryCompany) => {
  // return axios.get(Api.queryCompanyList, params);
  return axios.http({
    url: Api.queryCompanyList,
    headers: {
      isToken: false,
    },
    method: "get",
    params: params,
  });
};

// 部门搜索列表
export const getDeptList = (params: Visitor.queryDept) => {
  // return axios.get(Api.queryDeptList, params);
  return axios.http({
    url: Api.queryDeptList,
    headers: {
      isToken: false,
    },
    method: "get",
    params: params,
  });
};

// 人员搜索列表
export const getPersonList = (params: Visitor.queryPerson) => {
  // return axios.get(Api.queryPersonList, params);
  return axios.http({
    url: Api.queryPersonList,
    headers: {
      isToken: false,
    },
    method: "get",
    params: params,
  });
};
